<template>
    <div class="flex h-screen flex-col overflow-hidden lg:flex-row">
        <NavBar class="z-[999] shrink-0" :headerService="headerService" :navModuleType="NAV_MENU_TYPE.PATENT_DISCLOSURE" />
        <router-view></router-view>
    </div>
</template>
<script setup lang="ts">
import { headerService } from './services/header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/nav-bar';
import { EurekaModule, controlDeferred } from '@eureka/utils/control';
import _ from 'lodash';

controlDeferred.promise.then(({ ip_tab }) => {
    if ((!_.includes(ip_tab, EurekaModule.AI_PATENT_DISCLOSURE) && location.pathname !== '/403')) {
        location.href = '/403';
    }
});
</script>
